import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpErrorHandlerService, HandleError } from './http-error-handler.service';

import { Promozione, Categoria, ArticoloCategoria, CategoriaUpload, Articolo, Response, PromozioneDettaglioForUpdate, PromozioneDettaglio, Articoli } from '@app/_models';
import { environment } from '@environments/environment';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class PromoService {
  private promotionListEndpoint = "Promo/List";
  private promotionUploadEndpoint = "Promo/Upload";
  private promoArticletionUploadEndpoint = "Promo/UpdateDetail";
  private promotionDeleteEndpoint = "Promo/Delete";
  private detailListEndpoint = "Promo/Detail/List";
  private detailArticleCheck = "Promo/Detail/ArticleCheck";
  private detailArticleListini = "Promo/Detail/ArticleCheck/Listini";
  private categoryListEndpoint = "Promo/Category/List"
  private categoryUploadEndpoint = "Promo/Category/Upload"
  private categoryDeleteEndpoint = "Promo/Category/Delete"
  private categoryMergeEndpoint = "Promo/Category/Merge"
  private addProductPromo = "Promo/InsertProduct"
  private checkArticleEndPoint = "Promo/ChekArticleOnPromo"
  private checkNewCategorieEndPoint = "Promo/ChekNewCategory"
  //category
  private productRemoveEndPoint = "Promo/RemoveProductFromPromo"
  private ListProductOnCategory = "Promo/Category/GetProducts"
  private CategoryEndPoint = "Promo/Category/getCategory"
  private CategoryProductList ="Promo/Category/List/Product"
  private deleteProductFromCategory ="Promo/RemoveProductFromCategory"
  private deleteArrayOfProductFromcategory = "Promo/RemoveArrayOfProductFromCategory"
  private categoryAddProduct ="Promo/Category/InsertProduct"
  private listProductsForFilter = "Promo/Category/GetCodeValueData"
  private uploadArticleOnCategory = "Promo/Category/UploadArticleOnCategory"
  private exportCategory = "Promo/Category/ModifyExport"
  private handleError: HandleError;
  baseService: any;

  constructor(
    private http: HttpClient,
    httpErrorHandler: HttpErrorHandlerService,
    baseService : BaseService) {
    this.handleError = httpErrorHandler.createHandleError('PromoService');
    this.baseService = baseService;
  }

  promotionList(query: Promozione): Observable<Promozione[]> {
    return this.http.post<Response<Promozione[]>>(environment.apiURL+environment.apiVersion+this.promotionListEndpoint, query)
    .pipe(
      map(response => response.content),
      catchError(this.handleError(this.promotionListEndpoint))
    )
  }

  promotionUpload(promos: Promozione[] ): Observable<Promozione[]> {
   return this.baseService.postRequestNEW(promos,this.promotionUploadEndpoint)
  }
  promotionUploadArticle(article: PromozioneDettaglioForUpdate): Observable<PromozioneDettaglioForUpdate[]> {
    return this.http.post<Response<PromozioneDettaglioForUpdate[]>>(environment.apiURL+environment.apiVersion+this.promoArticletionUploadEndpoint, article)
    .pipe(
      map(response => response.content),
      catchError(this.handleError(this.promotionUploadEndpoint))
    )
  }

  promotionDelete(promos: Promozione[]): Observable<Promozione[]> {
    return this.http.post<Response<Promozione[]>>(environment.apiURL+environment.apiVersion+this.promotionDeleteEndpoint, promos)
    .pipe(
      map(response => response.content), 
      catchError(this.handleError(this.promotionDeleteEndpoint))
    )
  }

  // promotion merge

  detailList(query: Promozione): Observable<Articolo[]> {
    return this.http.post<Response<Articolo[]>>(environment.apiURL+environment.apiVersion+this.detailListEndpoint, query)
    .pipe(
      map(response => response.content),
      catchError(this.handleError(this.promotionListEndpoint))
    )
  }
  //checkArticle
  getArticoliCheck(codiceArticolo:string){
    return this.baseService.getOnceNEW(this.detailArticleCheck+ "?codArticle="+codiceArticolo.toString());
  }
  getListini(codiceArticolo:string){
    return this.baseService.getOnceNEW(this.detailArticleListini+ "?codArticle="+codiceArticolo.toString());
  }


  categoryList(query: Categoria): Observable<Categoria[]> {
    return this.http.post<Response<Categoria[]>>(environment.apiURL+environment.apiVersion + this.categoryListEndpoint, query)
    .pipe(
      map(response => response.content),
      catchError(this.handleError(this.categoryListEndpoint)),
    );
  }
  getCategory(categoryId:Number){
    return this.baseService.getOnceNEW(this.CategoryEndPoint+ "?categoryId="+categoryId.toString());
  }

  categoryUpload(cats: Categoria[], artCats: ArticoloCategoria[] = []): Observable<CategoriaUpload[]> {
    const uploadPackage: CategoriaUpload = { categorie: cats, relazioni: artCats };
    return this.http.post<Response<CategoriaUpload[]>>(environment.apiURL+environment.apiVersion + this.categoryUploadEndpoint, uploadPackage)
    .pipe(
      map(response => response.content),
      catchError(this.handleError(this.categoryUploadEndpoint)),
    );
  }
  categoryExport(cat: Categoria[] = []): Observable<Categoria[]> {
    return this.baseService.postRequestNEW(cat,this.exportCategory);
  }

  categoryDelete(cats: Categoria[]): Observable<Categoria[]> {
    return this.http.post<Response<Categoria[]>>(environment.apiURL+environment.apiVersion + this.categoryDeleteEndpoint, cats)
    .pipe(
      map(response => response.content),
      catchError(this.handleError(this.categoryDeleteEndpoint)),
    );
  }

  categoryMerge(cats: Categoria[]): Observable<Categoria[]> {
    return this.http.post<Response<Categoria[]>>(environment.apiURL+environment.apiVersion + this.categoryMergeEndpoint, cats)
    .pipe(
      map(response => response.content),
      catchError(this.handleError(this.categoryMergeEndpoint)),
    );
  }

  removeProductFromPromo(promoId : Number,articoloId : Number): Observable<any> {
     return this.baseService.getOnceNEW(this.productRemoveEndPoint+ "?promozioneId="+promoId.toString() +"&codiceProdotto=" + articoloId.toString());
  }

  //category 

  productList(categoryId:Number){
    return this.baseService.getOnceNEW(this.ListProductOnCategory+ "?categoryId="+categoryId.toString());
  }

  categoryArticleUpload(artCats: ArticoloCategoria[] = []): Observable<ArticoloCategoria[]> {
    return this.baseService.postRequestNEW(artCats,this.uploadArticleOnCategory);
  }
  // https://www.testim.io/blog/angular-testing-tutorial/
  
  categoryProductList(categoryId:Number): Observable<Articolo[]> {
    return this.baseService.getOnceNEW(this.CategoryProductList+"?categoryId="+categoryId);
  }

  removeProductFromCategory(categoryId : Number,articoloId : Number): Observable<any> {
    return this.baseService.getOnceNEW(this.deleteProductFromCategory+ "?categoryId="+categoryId.toString() +"&codiceProdotto=" + articoloId.toString());
 }

 removeArrayOfProductFromCategory(categoryId : Number,articoloId : string[]): Observable<any> {
  const params = {
    categoryId: categoryId,
    codiciProdotto:articoloId
  }
  return this.baseService.postRequestNEW(params,this.deleteArrayOfProductFromcategory);
}


 addProductOnCategory(articoloCategoria:ArticoloCategoria): Observable<any> {
  if (articoloCategoria) {
    return this.baseService.postRequestNEW(articoloCategoria, this.categoryAddProduct);
  }
  return of(null);
}
  listPrductForFilter(filter:string){
    if(filter){
      return this.baseService.getOnceNEW(this.listProductsForFilter + "?filter="+filter);
    }
    return of(null);
  }

  addProductOnPromo(promoDettaglio:PromozioneDettaglio): Observable<any> {
    if (promoDettaglio) {
      return this.baseService.postRequestNEW(promoDettaglio, this.addProductPromo);
    }
    return of(null);
  }

  checkArticleOnPromo(articoli:string[]): Observable<any> {
    if (articoli) {
      const params = {
        articoloId : articoli
      }
      return this.baseService.postRequestNEW(params, this.checkArticleEndPoint);
    }
    return of(null);
  }

 checkNewCategoriePromo(categorie:string[]): Observable<any> {
  if (categorie) {
    const params = {
      descrizione : categorie
    }
    return this.baseService.postRequestNEW(params, this.checkNewCategorieEndPoint);
  }
  return of(null);
 }
}
